// extracted by mini-css-extract-plugin
export default {"border_color":"divider_border_color__0GOYw","no_border":"divider_no_border__Mb2US"};